<template>
  <div style = "width: 100%; max-width: 85vw; max-height: 90vh; overflow: auto;">
    <img src = "../assets/Oxygen-Source-Type.jpg" style="width: 100%; min-width: 600px;">
  </div>
</template>

<script>

export default {
  name: 'SourceHelper',

  data () {
    return {}
  },
  computed: {
  },
  methods: {
  }
}
</script>
